import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import schedulerApiService from "../../../services/api/SchedulerApiService";

export default function VideoStatistics() {
  const { t } = useTranslation();

  const [videosWatchedThisWeek, setVideosWatchedThisWeek] = useState();

  useEffect(() => {
    const getVideosWatchedThisWeek = async () => {
      try {
        const NumberVideosWatchedThisWeek =
          await schedulerApiService.getVideosWatchedThisWeek();
        setVideosWatchedThisWeek(NumberVideosWatchedThisWeek);
      } catch (err) {
        console.error("Error fetching videos:", err);
      }
    };
    getVideosWatchedThisWeek();
  }, []);

  const movingTime = videosWatchedThisWeek * 2;

  let motivationText;

  if (movingTime === 0) {
    motivationText = <Typography>{t("motivationMessage1")}</Typography>;
  } else if (movingTime > 0 && movingTime < 15) {
    motivationText = <Typography>{t("motivationMessage2")}</Typography>;
  } else if (movingTime > 15 && movingTime < 45) {
    motivationText = <Typography>{t("motivationMessage3")}</Typography>;
  } else if (movingTime > 45 && movingTime < 60) {
    motivationText = <Typography>{t("motivationMessage4")}</Typography>;
  } else if (movingTime > 60 && movingTime < 70) {
    motivationText = <Typography>{t("motivationMessage5")}</Typography>;
  } else {
    motivationText = <Typography>{t("motivationMessage6")}</Typography>;
  }

  return (
    <Box sx={{ paddingBottom: "16px" }}>
      {motivationText}
      {movingTime > 0 ? (
        <Box sx={{ py: "10px" }}>
          <Typography>
            <span style={{ fontWeight: "bold" }}>{t("movement_time")}: </span>
            {movingTime}
          </Typography>
          <Typography>
            <span style={{ fontWeight: "bold" }}>{t("exercises")}: </span>
            {videosWatchedThisWeek}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
}
